// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"ac3c6076","40":"81c8d4b5","172":"d8fc4856","464":"54f6dfa8","728":"13823813"}[chunkId] + ".chunk.css";
};